var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('AboutWorld',{attrs:{"msg":"（株）HIRO ICT研究所について（工事中）"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }